module.exports = __webpack_public_path__ + "static/media/district2.f07233a3.pdf";